import { Text } from '@main/complykit';
import { useTranslation } from 'react-i18next';

/** An empty answer the reader cannot change, the same line for every kind:
 * muted text, never a blank and never an empty control (form-engine.md, "Modes"). */
export function NotAnswered() {
  const { t } = useTranslation();
  return (
    <Text size="sm" color="muted">
      {t('questionnaires.questions.notAnswered')}
    </Text>
  );
}
